var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 32.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_1-2",
    "data-name": "Laag 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M17,0l5.25,10.64L34,12.36l-8.5,8.28,2,11.7L17,26.81,6.49,32.33l2-11.7L0,12.36l11.75-1.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.3d07aa18dd26c4b2690d0a42e8a790a4.svg";
export { ForwardRef as ReactComponent };